export interface ITemperatureData {
  id: number;
  date: string;
  left: string;
  right: string;
}

export interface IProcessedTemperatureData extends ITemperatureData {
  leftTemperatures: number[];
  rightTemperatures: number[];
  averageLeftTemperature: number;
  averageRightTemperature: number;
  maxLeftTemperature: number;
  maxRightTemperature: number;
  minLeftTemperature: number;
  minRightTemperature: number;
}

export function processTemperatureData(data: ITemperatureData[]): IProcessedTemperatureData[] {
  return data.map((item) => {
    // Parse JSON strings into arrays of numbers
    // Handle cases where data might already be parsed or invalid
    let leftTemps: number[] = [];
    let rightTemps: number[] = [];

    try {
      // If it's already an array, use it directly
      if (Array.isArray(item.left)) {
        leftTemps = item.left as unknown as number[];
      } else if (typeof item.left === 'string') {
        leftTemps = JSON.parse(item.left) as number[];
      }
    } catch (error) {
      console.warn('Failed to parse left temperature data:', item.left, error);
      leftTemps = [];
    }

    try {
      // If it's already an array, use it directly
      if (Array.isArray(item.right)) {
        rightTemps = item.right as unknown as number[];
      } else if (typeof item.right === 'string') {
        rightTemps = JSON.parse(item.right) as number[];
      }
    } catch (error) {
      console.warn('Failed to parse right temperature data:', item.right, error);
      rightTemps = [];
    }

    // Calculate statistics using all temperature data
    const averageLeft = leftTemps.length > 0
      ? leftTemps.reduce((a, b) => a + b, 0) / leftTemps.length
      : 0;

    const averageRight = rightTemps.length > 0
      ? rightTemps.reduce((a, b) => a + b, 0) / rightTemps.length
      : 0;

    // Handle date field - server might send 'from' instead of 'date'
    const itemAny = item as any;
    const dateValue = item.date || itemAny.from || itemAny.to || '';

    return {
      ...item,
      date: dateValue, // Ensure date field exists
      leftTemperatures: leftTemps,
      rightTemperatures: rightTemps,
      averageLeftTemperature: averageLeft,
      averageRightTemperature: averageRight,
      maxLeftTemperature: leftTemps.length > 0 ? Math.max(...leftTemps) : 0,
      maxRightTemperature: rightTemps.length > 0 ? Math.max(...rightTemps) : 0,
      minLeftTemperature: leftTemps.length > 0 ? Math.min(...leftTemps) : 0,
      minRightTemperature: rightTemps.length > 0 ? Math.min(...rightTemps) : 0,
    };
  });
}
